import { __awaiter, __generator } from "tslib";
import { getAppDetailsFromFileType } from '@office-start/app-details-utility';
import { AppContentType, FileType } from '@office-start/document-types';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { getWdOrigin } from '@office-start/file-utility';
import { getAdditionalWacParamsFromLaunchParams } from '../utilities/getAdditionalParamsFromLaunchParams';
import { launchAppWacContent } from './launchAppWacContent';
import { launchDraftContent } from './launchDraftContent';
import { launchFluidContent } from './launchFluidContent';
import { launchMetaOSApp } from './launchMetaOSApp';
export function launchCustomContent(contentLaunchParams, launchInlineParams, launchParams, launchInstrumentationParams) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var capabilities, context, webUrl, document, useDeeplinkUrl, wdOriginType, shouldHandleMosContent, wdOrigin, appDetails, _b, featureGates;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    capabilities = launchParams.capabilities, context = launchParams.context, webUrl = launchParams.webUrl;
                    document = contentLaunchParams.document, useDeeplinkUrl = contentLaunchParams.useDeeplinkUrl, wdOriginType = contentLaunchParams.wdOriginType;
                    shouldHandleMosContent = document.fileType === FileType.ThirdParty;
                    wdOrigin = getWdOrigin(context.workload, context.router.getCurrentRoute(), wdOriginType !== null && wdOriginType !== void 0 ? wdOriginType : "OTHER" /* WdOriginType.Other */);
                    appDetails = getAppDetailsFromFileType(document, capabilities, 
                    // $TODO: isConsumer is only used to populate details
                    // for WAC case, but in this flow, it is not used to launchAppWacContent...
                    // changing this to false, since it is not used in this flow!
                    false, wdOrigin, webUrl, document.fileType);
                    if (!appDetails) return [3 /*break*/, 6];
                    _b = appDetails.type;
                    switch (_b) {
                        case AppContentType.WAC: return [3 /*break*/, 1];
                        case AppContentType.Fluid: return [3 /*break*/, 2];
                        case AppContentType.MOS: return [3 /*break*/, 4];
                        case AppContentType.Draft: return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 6];
                case 1: return [2 /*return*/, launchAppWacContent(document, context, launchInlineParams, wdOriginType, launchInstrumentationParams, useDeeplinkUrl, getAdditionalWacParamsFromLaunchParams(contentLaunchParams))];
                case 2: return [4 /*yield*/, fetchFeatureGates()];
                case 3:
                    featureGates = _c.sent();
                    if (!((_a = featureGates.result.fluidConfigGates) === null || _a === void 0 ? void 0 : _a.fluidConfigOpenExternallyEnabled)) {
                        return [2 /*return*/, launchFluidContent(appDetails, launchInlineParams.fluidHostFile, context, launchInstrumentationParams
                                ? launchInstrumentationParams.area
                                : 'Other')];
                    }
                    return [3 /*break*/, 6];
                case 4:
                    if (shouldHandleMosContent) {
                        return [2 /*return*/, launchMetaOSApp(appDetails, launchInstrumentationParams
                                ? launchInstrumentationParams.area
                                : 'Other')];
                    }
                    _c.label = 5;
                case 5: return [2 /*return*/, launchDraftContent(document, launchInstrumentationParams
                        ? launchInstrumentationParams.area
                        : 'Other')];
                case 6: return [2 /*return*/, Promise.resolve({
                        success: false,
                        message: 'launchCustomContent:fallThrough',
                    })];
            }
        });
    });
}
//# sourceMappingURL=launchCustomContent.js.map